var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmotionalsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2545 6.00357C12.2545 6.00357 12.2499 5.99817 12.2399 5.98797C12.2295 5.97737 12.2148 5.96317 12.1955 5.94597C12.1564 5.91107 12.1037 5.86837 12.0379 5.82237C11.9045 5.72927 11.7374 5.63617 11.5479 5.56417C11.178 5.42367 10.759 5.37387 10.2994 5.51267C9.32434 5.80717 8.76404 6.58597 8.40414 7.72027C8.24391 8.61697 8.25924 10.3425 9.08024 11.1538C9.32114 11.4225 9.84474 11.7631 10.5159 12.1996C11.9271 13.1176 13.9909 14.4599 15.4514 16.4507C16.4957 17.7819 15.4417 19.0664 14.9237 19.3491C14.2046 19.7416 13.5006 20.0147 12.6618 19.3491C11.8229 18.6835 10.4807 17.7259 9.02554 17.9819C7.57039 18.2379 6.99513 18.3335 6.14599 18.3335H1.79986C0.80575 18.3335 0 17.5276 0 16.5335V12.021C0 10.0638 1.23086 7.58087 3.19676 6.89867C3.83455 6.67737 4.43919 6.26467 4.69701 5.64067C5.37822 3.99217 6.63931 2.23067 9.08514 1.49197C12.0681 0.591072 14.5225 2.18337 15.4587 3.28807C16.2085 4.17287 16.0991 5.49807 15.2143 6.24787C14.3295 6.99767 13.0044 6.88837 12.2545 6.00357Z",
    fill: "url(#paint0_radial_34_1295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2545 6.00357C12.2545 6.00357 12.2499 5.99817 12.2399 5.98797C12.2295 5.97737 12.2148 5.96317 12.1955 5.94597C12.1564 5.91107 12.1037 5.86837 12.0379 5.82237C11.9045 5.72927 11.7374 5.63617 11.5479 5.56417C11.178 5.42367 10.759 5.37387 10.2994 5.51267C9.32434 5.80717 8.76404 6.58597 8.40414 7.72027C8.24391 8.61697 8.25924 10.3425 9.08024 11.1538C9.32114 11.4225 9.84474 11.7631 10.5159 12.1996C11.9271 13.1176 13.9909 14.4599 15.4514 16.4507C16.4957 17.7819 15.4417 19.0664 14.9237 19.3491C14.2046 19.7416 13.5006 20.0147 12.6618 19.3491C11.8229 18.6835 10.4807 17.7259 9.02554 17.9819C7.57039 18.2379 6.99513 18.3335 6.14599 18.3335H1.79986C0.80575 18.3335 0 17.5276 0 16.5335V12.021C0 10.0638 1.23086 7.58087 3.19676 6.89867C3.83455 6.67737 4.43919 6.26467 4.69701 5.64067C5.37822 3.99217 6.63931 2.23067 9.08514 1.49197C12.0681 0.591072 14.5225 2.18337 15.4587 3.28807C16.2085 4.17287 16.0991 5.49807 15.2143 6.24787C14.3295 6.99767 13.0044 6.88837 12.2545 6.00357Z",
    fill: "url(#paint1_radial_34_1295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2545 6.00357C12.2545 6.00357 12.2499 5.99817 12.2399 5.98797C12.2295 5.97737 12.2148 5.96317 12.1955 5.94597C12.1564 5.91107 12.1037 5.86837 12.0379 5.82237C11.9045 5.72927 11.7374 5.63617 11.5479 5.56417C11.178 5.42367 10.759 5.37387 10.2994 5.51267C9.32434 5.80717 8.76404 6.58597 8.40414 7.72027C8.24391 8.61697 8.25924 10.3425 9.08024 11.1538C9.32114 11.4225 9.84474 11.7631 10.5159 12.1996C11.9271 13.1176 13.9909 14.4599 15.4514 16.4507C16.4957 17.7819 15.4417 19.0664 14.9237 19.3491C14.2046 19.7416 13.5006 20.0147 12.6618 19.3491C11.8229 18.6835 10.4807 17.7259 9.02554 17.9819C7.57039 18.2379 6.99513 18.3335 6.14599 18.3335H1.79986C0.80575 18.3335 0 17.5276 0 16.5335V12.021C0 10.0638 1.23086 7.58087 3.19676 6.89867C3.83455 6.67737 4.43919 6.26467 4.69701 5.64067C5.37822 3.99217 6.63931 2.23067 9.08514 1.49197C12.0681 0.591072 14.5225 2.18337 15.4587 3.28807C16.2085 4.17287 16.0991 5.49807 15.2143 6.24787C14.3295 6.99767 13.0044 6.88837 12.2545 6.00357Z",
    fill: "url(#paint2_radial_34_1295)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2545 6.00357C12.2545 6.00357 12.2499 5.99817 12.2399 5.98797C12.2295 5.97737 12.2148 5.96317 12.1955 5.94597C12.1564 5.91107 12.1037 5.86837 12.0379 5.82237C11.9045 5.72927 11.7374 5.63617 11.5479 5.56417C11.178 5.42367 10.759 5.37387 10.2994 5.51267C9.32434 5.80717 8.76404 6.58597 8.40414 7.72027C8.24391 8.61697 8.25924 10.3425 9.08024 11.1538C9.32114 11.4225 9.84474 11.7631 10.5159 12.1996C11.9271 13.1176 13.9909 14.4599 15.4514 16.4507C16.4957 17.7819 15.4417 19.0664 14.9237 19.3491C14.2046 19.7416 13.5006 20.0147 12.6618 19.3491C11.8229 18.6835 10.4807 17.7259 9.02554 17.9819C7.57039 18.2379 6.99513 18.3335 6.14599 18.3335H1.79986C0.80575 18.3335 0 17.5276 0 16.5335V12.021C0 10.0638 1.23086 7.58087 3.19676 6.89867C3.83455 6.67737 4.43919 6.26467 4.69701 5.64067C5.37822 3.99217 6.63931 2.23067 9.08514 1.49197C12.0681 0.591072 14.5225 2.18337 15.4587 3.28807C16.2085 4.17287 16.0991 5.49807 15.2143 6.24787C14.3295 6.99767 13.0044 6.88837 12.2545 6.00357Z",
    fill: "url(#paint3_radial_34_1295)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79675 4.52372C9.54585 4.06412 10.513 4.14232 11.1455 4.45852C12.1828 4.97722 13.4442 4.55672 13.9629 3.51942C14.4816 2.48202 14.0611 1.22062 13.0237 0.701915C11.4034 -0.108195 8.85475 -0.439545 6.60007 0.944015C3.51282 2.83842 3.24316 5.83822 3.24316 7.80272C3.24316 8.96252 4.18336 9.90272 5.34316 9.90272C6.50296 9.90272 7.44316 8.96252 7.44316 7.80272C7.44316 6.16612 7.68352 5.20682 8.79675 4.52372Z",
    fill: "url(#paint4_radial_34_1295)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79675 4.52372C9.54585 4.06412 10.513 4.14232 11.1455 4.45852C12.1828 4.97722 13.4442 4.55672 13.9629 3.51942C14.4816 2.48202 14.0611 1.22062 13.0237 0.701915C11.4034 -0.108195 8.85475 -0.439545 6.60007 0.944015C3.51282 2.83842 3.24316 5.83822 3.24316 7.80272C3.24316 8.96252 4.18336 9.90272 5.34316 9.90272C6.50296 9.90272 7.44316 8.96252 7.44316 7.80272C7.44316 6.16612 7.68352 5.20682 8.79675 4.52372Z",
    fill: "url(#paint5_radial_34_1295)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.401 4.52372C18.6519 4.06412 17.6848 4.14232 17.0523 4.45852C16.0149 4.97722 14.7535 4.55672 14.2349 3.51942C13.7162 2.48202 14.1367 1.22062 15.174 0.701915C16.7943 -0.108195 19.343 -0.439545 21.5976 0.944015C24.6849 2.83842 24.9545 5.83822 24.9545 7.80272C24.9545 8.96252 24.0143 9.90272 22.8545 9.90272C21.6947 9.90272 20.7545 8.96252 20.7545 7.80272C20.7545 6.16612 20.5142 5.20682 19.401 4.52372Z",
    fill: "#E2B498"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.401 4.52372C18.6519 4.06412 17.6848 4.14232 17.0523 4.45852C16.0149 4.97722 14.7535 4.55672 14.2349 3.51942C13.7162 2.48202 14.1367 1.22062 15.174 0.701915C16.7943 -0.108195 19.343 -0.439545 21.5976 0.944015C24.6849 2.83842 24.9545 5.83822 24.9545 7.80272C24.9545 8.96252 24.0143 9.90272 22.8545 9.90272C21.6947 9.90272 20.7545 8.96252 20.7545 7.80272C20.7545 6.16612 20.5142 5.20682 19.401 4.52372Z",
    fill: "url(#paint6_radial_34_1295)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.401 4.52372C18.6519 4.06412 17.6848 4.14232 17.0523 4.45852C16.0149 4.97722 14.7535 4.55672 14.2349 3.51942C13.7162 2.48202 14.1367 1.22062 15.174 0.701915C16.7943 -0.108195 19.343 -0.439545 21.5976 0.944015C24.6849 2.83842 24.9545 5.83822 24.9545 7.80272C24.9545 8.96252 24.0143 9.90272 22.8545 9.90272C21.6947 9.90272 20.7545 8.96252 20.7545 7.80272C20.7545 6.16612 20.5142 5.20682 19.401 4.52372Z",
    fill: "url(#paint7_radial_34_1295)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6396 6.00357C15.6396 6.00357 15.6442 5.99817 15.6542 5.98797C15.6646 5.97737 15.6793 5.96317 15.6986 5.94597C15.7377 5.91107 15.7904 5.86837 15.8562 5.82237C15.9896 5.72927 16.1567 5.63617 16.3462 5.56417C16.7161 5.42367 17.1351 5.37387 17.5947 5.51267C18.5698 5.80717 19.1301 6.58597 19.49 7.72027C19.6502 8.61697 19.6349 10.3425 18.8139 11.1538C18.573 11.4225 18.0494 11.7631 17.3782 12.1996C15.967 13.1176 13.9032 14.4599 12.4427 16.4507C11.3984 17.7819 12.3478 19.1914 12.8658 19.4741C13.5849 19.8666 14.3935 20.0147 15.2323 19.3491C16.0712 18.6835 17.4134 17.7259 18.8686 17.9819C20.3237 18.2379 20.899 18.3335 21.7482 18.3335H26.0943C27.0884 18.3335 27.8941 17.5276 27.8941 16.5335V12.021C27.8941 10.0638 26.6633 7.58087 24.6974 6.89867C24.0596 6.67737 23.4549 6.26467 23.1971 5.64067C22.5159 3.99217 21.2548 2.23067 18.809 1.49197C15.826 0.591072 13.3716 2.18337 12.4354 3.28807C11.6856 4.17287 11.795 5.49807 12.6798 6.24787C13.5646 6.99767 14.8897 6.88837 15.6396 6.00357Z",
    fill: "#F4BEAE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.291 2.44279C18.666 2.40109 21.566 3.28659 22.541 7.16159",
    stroke: "url(#paint8_linear_34_1295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.041 8.13086C24.8431 8.50586 26.4473 9.76836 26.4473 11.8184V16.0372",
    stroke: "url(#paint9_radial_34_1295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7285 17.7872C14.2493 16.933 16.2222 15.1184 17.8222 13.9434",
    stroke: "url(#paint10_linear_34_1295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70943 9.03711C6.60526 9.83921 6.80318 11.6433 8.42818 12.4433C10.1037 13.5058 11.5428 14.5683 12.0845 15.1308",
    stroke: "url(#paint11_linear_34_1295)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3534 9.94557) rotate(152.241) scale(10.7355 9.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.187907,
    stopColor: "#FBC4B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D89E89"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8534 19.8085) rotate(-161.777) scale(7.76442 5.36053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0642186,
    stopColor: "#CC8E92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8E92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6346 15.2241) rotate(-128.919) scale(6.46664 2.55443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE967D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE967D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7283 5.80397) rotate(132.1) scale(5.08076 3.87854)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.365468,
    stopColor: "#C5837E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0908A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.2287 1.41112) rotate(142.891) scale(10.4626 11.5605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD0B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAB195"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.0412 5.38262) rotate(127.518) scale(4.56688 3.36003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.532262,
    stopColor: "#DBA486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA486",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.1974 6.66112) rotate(-136.324) scale(14.3448 4.44683)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.380838,
    stopColor: "#FFE3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3C2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9474 4.28882) rotate(40.4898) scale(4.35557 2.55906)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.466894,
    stopColor: "#FFC4A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC4A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34_1295",
    x1: 22.541,
    y1: 7.16159,
    x2: 13.6348,
    y2: 1.22409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_34_1295",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1036 9.44336) rotate(144.039) scale(7.87599 5.78747)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.324876,
    stopColor: "#FFE4C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34_1295",
    x1: 14.166,
    y1: 18.0997,
    x2: 17.7583,
    y2: 12.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFBCB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBCB1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34_1295",
    x1: 10.0724,
    y1: 10.7585,
    x2: 7.86635,
    y2: 14.5046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD3BC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionalsupport);
export default __webpack_public_path__ + "static/media/Emotional support.1958409612ec704cf8fa9507341f8c1a.svg";
export { ForwardRef as ReactComponent };